import { Interview } from "../../../../api/Interviews";

// function to check after vs before changes on field level, if any
export const validateInterviewFieldChanges = (payload: Interview, previousPayload: Interview) => {
    const changedFields: { [key: string]: { before: any; after: any } } = {};

    Object.keys(payload).forEach((key) => {
        const fieldKey = key as keyof Interview;
        if (payload[fieldKey] !== previousPayload[fieldKey]) {
            changedFields[fieldKey] = {
                before: previousPayload[fieldKey],
                after: payload[fieldKey]
            };
        }
    });

    return changedFields;
}